import {HttpClient} from "helpers/http/httpClient";
import { GeneralSpecializationResult } from "services/lookupService/models/LookupsType";
import {
    BaseResponseType,
    CentreManagementLocalResult,
    DataGridRequest,
    FileDownload,
    PagedResult,
} from "services/shared-models/sharedTypes";
import {
    CreateCourseOrderRequest,
    CourseOrderResult,
    CourseOrderLocalResult,
    CourseOrderLocalItemResult,
    UpdateCenterManagerRequest,
    CourseOrderActionResult,
    UpdateCourseEvaluationOrderRequest,
    UpdateCourseOrderISBNRequest,
    UpdateCourseOrderAmountRequest,
    ReturnCourseOrderRequest,
    ReturnCourseOrderRefereeRequest,
} from "./models/CourseOrderType";

export const CourseOrderService = {
    createCourseOrder: async (createCourseOrderRequest: CreateCourseOrderRequest) => {
        return await HttpClient.post<BaseResponseType<CourseOrderResult>>(
            "/api/CourseOrder/CreateCourseOrder",
            createCourseOrderRequest,
        );
    },

    updateCourseOrder: async (id: number, createOrderRequest: CreateCourseOrderRequest) => {
        return await HttpClient.put<BaseResponseType<CourseOrderResult>>(
            `/api/CourseOrder/UpdateCourseOrder/${id}`,
            createOrderRequest,
        );
    },

    getAllCourseOrders: async (request: DataGridRequest) => {
        return await HttpClient.post<BaseResponseType<PagedResult<CourseOrderLocalResult>>>(
            "/api/CourseOrder/GetAllCourseOrders",
            request,
        );
    },

    getCourseOrderById: async (id: number) => {
        return await HttpClient.get<BaseResponseType<CourseOrderLocalItemResult>>(
            `/api/CourseOrder/GetCourseOrderById/${id}`,
        );
    },

    deleteCourseOrder: async (id: number) => {
        return await HttpClient.delete<BaseResponseType<CourseOrderResult>>(`/api/CourseOrder/DeleteCourseOrder/${id}`);
    },

    exportCourseOrdersToExcel: async (request: DataGridRequest) => {
        return await HttpClient.post<FileDownload>("/api/CourseOrder/ExportCourseOrdersToExcel", request, {
            responseType: "blob",
        });
    },

    getAllMyCourseOrder: async (request: DataGridRequest) => {
        return await HttpClient.post<BaseResponseType<PagedResult<CourseOrderLocalResult>>>(
            "/api/CourseOrder/GetAllMyCourseOrder",
            request,
        );
    },

    getAllMyCourseOrderPublishingStatus: async (request: DataGridRequest) => {
        return await HttpClient.post<BaseResponseType<PagedResult<CourseOrderLocalResult>>>(
            "/api/CourseOrder/GetAllMyCourseOrderPublishingStatus",
            request,
        );
    },

    exportMyCourseOrderToExcel: async (request: DataGridRequest) => {
        return await HttpClient.post<FileDownload>("/api/CourseOrder/ExportMyCourseOrderToExcel", request, {
            responseType: "blob",
        });
    },

    exportMyCourseOrderPublishingStatusToExcel: async (request: DataGridRequest) => {
        return await HttpClient.post<FileDownload>("/api/CourseOrder/ExportMyCourseOrderPublishingStatusToExcel", request, {
            responseType: "blob",
        });
    },

    getManagementCentersDropdown: async (request: DataGridRequest) => {
        return await HttpClient.post<BaseResponseType<PagedResult<CentreManagementLocalResult>>>(
            `/api/CourseOrder/GetManagementCentersDropdown`,
            request,
        );
    },
    GetAllScientificSpecializationsByCentreId: async ({id}:any) => {
       const result= await HttpClient.post<BaseResponseType<PagedResult<GeneralSpecializationResult>>>(
            `/api/CourseOrder/GetAllScientificSpecializationsByCentreId/${id}`
        );
       return result;
    },
    
    
    UpdateCenterManager: async (courseOrderId: number, request: UpdateCenterManagerRequest) => {
        return await HttpClient.put<BaseResponseType<CourseOrderResult>>(
            `/api/CourseOrder/UpdateCenterManager/${courseOrderId}`,
            request,
        );
    }, getAllActionsCourseOrderByOrderId: async (courseOrderId: number) => {
        return await HttpClient.get<BaseResponseType<CourseOrderActionResult[]>>(
            `/api/CourseOrder/GetAllActionsCourseOrderByOrderId/${courseOrderId}`);
    },
    updateCourseEvaluationOrder: async (programOrderEvaluationId: number, data: UpdateCourseEvaluationOrderRequest) => {
        return await HttpClient.put<BaseResponseType<any>>(
            `/api/CourseOrder/updateCourseEvaluationOrder?programOrderEvaluationId=${programOrderEvaluationId}`, data);
    },
    UpdateRefereeEvaluationOrder: async (programOrderEvaluationId: number, data: UpdateCourseEvaluationOrderRequest) => {
        return await HttpClient.put<BaseResponseType<any>>(
            `/api/CourseOrder/UpdateRefereeEvaluationOrder?programOrderEvaluationId=${programOrderEvaluationId}`, data);
    },
    updateCourseOrderISBN: async (id: number, data: UpdateCourseOrderISBNRequest) => {
        return await HttpClient.put<BaseResponseType<CourseOrderResult>>(
            `/api/CourseOrder/UpdateCourseOrderISBN/${id}`, data
        );
    },
    updateCourseOrderAmount: async (id: number, data: UpdateCourseOrderAmountRequest) => {
        return await HttpClient.put<BaseResponseType<CourseOrderResult>>(
            `/api/CourseOrder/UpdateCourseOrderAmount/${id}`, data
        );
    },
    returnCourseOrder: async (courseOrderId: number, request: ReturnCourseOrderRequest) => {
        return await HttpClient.put<BaseResponseType<CourseOrderResult>>(
            `/api/CourseOrder/ReturnCourseOrder/${courseOrderId}`,
            request,
        );
    },

    returnRefereeCourseOrder: async (courseOrderId: number, request: ReturnCourseOrderRefereeRequest) => {
        return await HttpClient.put<BaseResponseType<CourseOrderResult>>(
            `/api/CourseOrder/ReturnRefereeCourseOrder/${courseOrderId}`,
            request,
        );
    },
    UpdateRefereeEvaluationOrderIterations: async (courseOrderEvaluationId: number) => {
        return await HttpClient.put<BaseResponseType<any>>(
            `/api/CourseOrder/UpdateRefereeEvaluationOrderIterations/${courseOrderEvaluationId}`
        );
    },

    UpdateEvaluationOrderIterations: async (courseOrderEvaluationId: number) => {
        return await HttpClient.put<BaseResponseType<any>>(
            `/api/CourseOrder/UpdateEvaluationOrderIterations/${courseOrderEvaluationId}`
        );
    }

};

